import checkedWhite from 'src/assets/checked_white.svg';
import './style.scoped.css';

const Checkbox = (props) => {
  const { checked, onCheck, text, textComponent, type = 'normal', changeBackground = true, className = '' } = props;
  const _getCheckBoxClassName = () => {
    switch (type) {
      case 'normal':
      case 'card':
        if (checked) return 'border-primary bg-primary';
        return 'border-primary bg-transparent';
      default:
        if (checked) return 'border-primary bg-primary';
        return 'border-label';
    }
  };

  const _getCardClassName = () => {
    if (checked) {
      return changeBackground ? 'bg-primaryLight3' : '';
    }
    return 'bg-surface';
  };

  const _getTextClassName = () => {
    return 'text-onSurface';
  };

  if(type === "individual") {
    return (
      <div
        className={`flex p-5 rounded-lg ${_getCardClassName()} ${className}`}
      >
        <div
          onClick={onCheck}
          className={`flex items-center justify-center w-5 h-5 border-2 rounded-md ${_getCheckBoxClassName()}`}
        >
          {!!checked && (
            <div>
              <img src={checkedWhite} className="checkIcon" />
            </div>
          )}
        </div>
        <div
          className={`ml-4 text-sm whitespace-pre-wrap flex-1 ${_getTextClassName()}`}
        >
          {textComponent ? textComponent : text}
        </div>
      </div>
    )
  }

  if (type === 'card') {
    return (
      <div
        className={`flex p-5 rounded-lg ${_getCardClassName()} ${className}`}
        onClick={onCheck}
      >
        <div
          className={`flex items-center justify-center w-5 h-5 border-2 rounded-md ${_getCheckBoxClassName()}`}
        >
          {!!checked && (
            <div>
              <img src={checkedWhite} className="checkIcon" />
            </div>
          )}
        </div>
        <div
          className={`ml-4 text-sm whitespace-pre-wrap flex-1 ${_getTextClassName()}`}
        >
          {textComponent ? textComponent : text}
        </div>
      </div>
    );
  }
  return (
    <div className="flex items-center" onClick={onCheck}>
      <div
        className={`flex items-center w-5 h-5 border-2 rounded-md ${_getCheckBoxClassName()} ${className}`}
      >
        {!!checked && <img src={checkedWhite} className="m-auto w-3 h-2" />}
      </div>
      <div className="ml-3 text-sm text-label flex-1">{text}</div>
    </div>
  );
};

export default Checkbox;
